class Popup extends HTMLElement {
  constructor() {
    super();
    this.popupContainer = null;
    this.popupOverlay = null;
    this.closeLink = null;
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    this.classList.remove('enter');

    requestAnimationFrame(() => {
      this.classList.add('enter');
    });
  }

  init() {
    const parentElement = this.parentElement;

    this.popupContainer = this.querySelector('.popup--content');
    this.closeLink = this.querySelector('.popup--content .link');
    this.popupOverlay = parentElement.querySelector('.info-popup--overlay');

    if (!this.popupContainer || !this.popupOverlay) return;

    if (this.shouldOpen) {
      this.open();
      localStorage.setItem('NLVisibleTimestamp', Date.now());
    }

    if (this.closeLink) {
      this.closeLink.addEventListener("click", this.close.bind(this));
    }
    if(this.popupOverlay){
      this.popupOverlay.addEventListener("click", this.close.bind(this));
    }
     window.addEventListener('click', (e) => {
    if (
      this.popupContainer.classList.contains('is-active') &&
      !this.contains(e.target) &&
      !this.popupContainer.contains(e.target)
    ) {
      this.close();
    }
  });
  }

  get showOnlyOnce() {
    return this.dataset.showOnce === "true";
  }

  get shouldOpen() {
    if (!this.showOnlyOnce) return true;

    const timestamp = localStorage.getItem('NLVisibleTimestamp');
    if (!timestamp) return true;

    const expiryDate = Number(timestamp) + 7 * 24 * 60 * 60 * 1000;
    return Date.now() > expiryDate;
  }

  open() {
    this.popupContainer.classList.remove('slide-out');
    this.popupContainer.classList.add('is-active');
    this.popupOverlay.classList.add('is-active');
  }
  close() {
    this.popupContainer.classList.add('slide-out');
    this.popupContainer.addEventListener(
      "transitionend",
      () => {
        this.popupContainer.classList.remove('slide-out');
        this.popupContainer.classList.remove('is-active');
        this.popupOverlay.classList.remove('is-active');
      },
      { once: true }
    );
  }
}

customElements.define("popup-info", Popup);
